import axios from 'axios'

const instance = axios.create()
let appId = window.location.hostname.split('.')[0]
// if (process.env.NODE_ENV === 'development') {
//   appId = 'wx129eaf6876332fba'
// }

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const userInfo = localStorage.getItem('userInfo')
    if (config.method === 'get') {
      if(!config.params) {
        config.params = {}
      }
      config.params.appId = appId
    } else if ( config.method === 'post') {
      if(!config.data) {
        config.data = {}
      }
      config.data.appId = appId
    }
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

export function get (url, params) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, { params })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
